import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\ProfileInertiaController::profile
* @see app/Http/Controllers/User/ProfileInertiaController.php:27
* @route '/user/profile'
*/
export const profile = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

profile.definition = {
    methods: ["get","head"],
    url: '/user/profile',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::profile
* @see app/Http/Controllers/User/ProfileInertiaController.php:27
* @route '/user/profile'
*/
profile.url = (options?: RouteQueryOptions) => {
    return profile.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::profile
* @see app/Http/Controllers/User/ProfileInertiaController.php:27
* @route '/user/profile'
*/
profile.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::profile
* @see app/Http/Controllers/User/ProfileInertiaController.php:27
* @route '/user/profile'
*/
profile.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: profile.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::profile
* @see app/Http/Controllers/User/ProfileInertiaController.php:27
* @route '/user/profile'
*/
const profileForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::profile
* @see app/Http/Controllers/User/ProfileInertiaController.php:27
* @route '/user/profile'
*/
profileForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::profile
* @see app/Http/Controllers/User/ProfileInertiaController.php:27
* @route '/user/profile'
*/
profileForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

profile.form = profileForm

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitProfile
* @see app/Http/Controllers/User/ProfileInertiaController.php:41
* @route '/user/profile/submit'
*/
export const submitProfile = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submitProfile.url(options),
    method: 'post',
})

submitProfile.definition = {
    methods: ["post"],
    url: '/user/profile/submit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitProfile
* @see app/Http/Controllers/User/ProfileInertiaController.php:41
* @route '/user/profile/submit'
*/
submitProfile.url = (options?: RouteQueryOptions) => {
    return submitProfile.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitProfile
* @see app/Http/Controllers/User/ProfileInertiaController.php:41
* @route '/user/profile/submit'
*/
submitProfile.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submitProfile.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitProfile
* @see app/Http/Controllers/User/ProfileInertiaController.php:41
* @route '/user/profile/submit'
*/
const submitProfileForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submitProfile.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitProfile
* @see app/Http/Controllers/User/ProfileInertiaController.php:41
* @route '/user/profile/submit'
*/
submitProfileForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submitProfile.url(options),
    method: 'post',
})

submitProfile.form = submitProfileForm

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::changePassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:92
* @route '/user/profile/change-password'
*/
export const changePassword = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changePassword.url(options),
    method: 'get',
})

changePassword.definition = {
    methods: ["get","head"],
    url: '/user/profile/change-password',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::changePassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:92
* @route '/user/profile/change-password'
*/
changePassword.url = (options?: RouteQueryOptions) => {
    return changePassword.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::changePassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:92
* @route '/user/profile/change-password'
*/
changePassword.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changePassword.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::changePassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:92
* @route '/user/profile/change-password'
*/
changePassword.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: changePassword.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::changePassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:92
* @route '/user/profile/change-password'
*/
const changePasswordForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changePassword.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::changePassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:92
* @route '/user/profile/change-password'
*/
changePasswordForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changePassword.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::changePassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:92
* @route '/user/profile/change-password'
*/
changePasswordForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changePassword.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

changePassword.form = changePasswordForm

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitPassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:110
* @route '/user/profile/change-password'
*/
export const submitPassword = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submitPassword.url(options),
    method: 'post',
})

submitPassword.definition = {
    methods: ["post"],
    url: '/user/profile/change-password',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitPassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:110
* @route '/user/profile/change-password'
*/
submitPassword.url = (options?: RouteQueryOptions) => {
    return submitPassword.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitPassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:110
* @route '/user/profile/change-password'
*/
submitPassword.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submitPassword.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitPassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:110
* @route '/user/profile/change-password'
*/
const submitPasswordForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submitPassword.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\ProfileInertiaController::submitPassword
* @see app/Http/Controllers/User/ProfileInertiaController.php:110
* @route '/user/profile/change-password'
*/
submitPasswordForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submitPassword.url(options),
    method: 'post',
})

submitPassword.form = submitPasswordForm

const ProfileInertiaController = { profile, submitProfile, changePassword, submitPassword }

export default ProfileInertiaController